import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from 'react-i18next';
import { HelperText } from '../HelperText/HelperText';
import { dataBoxStyles } from './dataBoxStyles';

export interface IDataBoxProps {
  title: string;
  content;
  unit?: string;
  isRoi?: boolean;
}

export const DataBox = ({ title, content, unit, isRoi }: IDataBoxProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isDark = theme.palette.mode === 'dark';
  const classes = dataBoxStyles(theme, isDark);
  const isDownLg = useMediaQuery(theme.breakpoints.down('lg'));
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'));
  const typographyVariantTitle = isDownLg ? 'subtitle2' : 'subtitle1';
  const typographyVariantSubtitle = isDownLg ? 'body2' : 'body1';
  const typographyVariant = isDownSm ? 'subtitle2' : 'subtitle2';
  return (
    <Grid
      item
      container
      xs={12}
      direction='column'
      justifyContent='space-between'
      sx={classes.cellWallet}
    >
      {isRoi ? (
        <Grid item container wrap='nowrap' alignItems='center'>
          <Grid item>
            <Typography
              variant={typographyVariantTitle}
              color={theme.palette.secondary.main}
              sx={classes.dataTitle}
            >
              {title}
            </Typography>
          </Grid>
          <Grid item>
            <HelperText
              text={t('vesting.card_data.data_box.roi.helper_text')}
            />
          </Grid>
        </Grid>
      ) : (
        <Grid item>
          <Typography
            variant={typographyVariantTitle}
            color={theme.palette.secondary.main}
            sx={classes.dataTitle}
          >
            {title}
          </Typography>
        </Grid>
      )}
      <Grid item container direction='row' alignItems='flex-end'>
        <Grid item>
          <Typography
            variant={typographyVariantSubtitle}
            sx={classes.dataNumber}
          >
            {content}
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            variant={typographyVariant}
            color='secondary'
            sx={classes.dataUnit}
          >
            {unit}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
